import { render, staticRenderFns } from "./JournalistRegisterForm.vue?vue&type=template&id=49b1608c"
import script from "./JournalistRegisterForm.vue?vue&type=script&lang=js"
export * from "./JournalistRegisterForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports